import { render, staticRenderFns } from "./PromoSubvendorSelect.vue?vue&type=template&id=2b857c55&"
import script from "./PromoSubvendorSelect.vue?vue&type=script&lang=js&"
export * from "./PromoSubvendorSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VChip,VContainer})
